import { ISoccerMatchListItem, SoccerMatchStatus } from "../../../types";
import { useAppStore } from "../stores/useAppStore";

/**
 * Simple utility to check if there are multiple live matches and update the store
 * @param matches Array of matches to check
 */
export function updateMultipleLiveMatchesState(matches: ISoccerMatchListItem[]) {
  const liveMatches = matches.filter(
    (match) => match.status === SoccerMatchStatus.PLAYING
  );
  
  const hasMultipleLiveMatches = liveMatches.length > 1;
  
  // Update the store state
  useAppStore.getState().setHasMultipleLiveMatches(hasMultipleLiveMatches);
  
  return {
    hasMultipleLiveMatches,
    liveMatchCount: liveMatches.length,
    liveMatches,
  };
}
